module.exports = __webpack_public_path__ + "img/pipedrive-logo.a67ac5e0.png";